/* Offer claim meter (2026-10-04).
   Each [data-al-claims] block shows "<claimed> of <pool> offers claimed", a fill
   bar and "Only <n> offers remaining". Every 25-35s the claimed count ticks up
   by 1 and the bar eases wider. State persists per key in localStorage so a
   return visit continues where it left off, reseeds each calendar day so it
   never looks stuck, and floors at 3 remaining so the offer never reads as
   gone while it is still purchasable. */
(function () {
  'use strict';

  var FLOOR = 3; // never fewer than this many remaining

  function read(key) {
    try { return JSON.parse(localStorage.getItem('alClaims:' + key)); } catch (e) { return null; }
  }
  function write(key, val) {
    try { localStorage.setItem('alClaims:' + key, JSON.stringify(val)); } catch (e) { /* private mode */ }
  }
  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  function init(el) {
    var key = el.getAttribute('data-claims-key') || 'offer';
    var pool = parseInt(el.getAttribute('data-claims-pool'), 10) || 200;
    var start = parseInt(el.getAttribute('data-claims-start'), 10) || Math.round(pool * 0.85);
    var max = pool - FLOOR;

    var claimedEl = el.querySelector('[data-claims-claimed]');
    var remainEl = el.querySelector('[data-claims-remaining]');
    var fillEl = el.querySelector('[data-claims-fill]');
    if (!claimedEl || !remainEl || !fillEl) return;

    var claimed = Math.min(start, max);

    var saved = read(key);
    if (saved && saved.d === today() && typeof saved.c === 'number') {
      claimed = Math.min(Math.max(saved.c, claimed), max);
    }
    write(key, { d: today(), c: claimed });

    function render(animate) {
      claimedEl.textContent = claimed;
      remainEl.textContent = pool - claimed;
      fillEl.style.width = (claimed / pool * 100).toFixed(1) + '%';
      if (animate) {
        [claimedEl, remainEl].forEach(function (n) {
          n.classList.remove('is-ticking');
          void n.offsetWidth; /* restart the animation */
          n.classList.add('is-ticking');
        });
      }
    }
    render(false);

    /* First tick 10s after load, second 7s later, then every 15-30s. */
    var tickNo = 0;
    function schedule() {
      var wait;
      if (tickNo === 0) wait = 10000;
      else if (tickNo === 1) wait = 7000;
      else wait = 15000 + Math.random() * 15000;
      setTimeout(function () {
        tickNo += 1;
        if (claimed < max) {
          claimed += 1;
          write(key, { d: today(), c: claimed });
          /* Only animate when the tab is actually being looked at. */
          render(document.visibilityState !== 'hidden');
        }
        schedule();
      }, wait);
    }
    schedule();
  }

  function boot() {
    var seen = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-al-claims]'), function (el) {
      var key = el.getAttribute('data-claims-key') || 'offer';
      /* One ticker per key even if the block renders twice (e.g. duplicate
         sections); the extras mirror the same stored state on load. */
      if (seen[key]) return;
      seen[key] = true;
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
